import { Container } from '@/atoms';
import { RecipeArticle } from '@/templates';
import { getUrlFromMedia } from "@/utils/utils";
import { NodeProps } from "components/node";
import { StructuredData } from 'components/structured-data/structured-data';


export function Recipe({ content }: NodeProps) {
    const relatedRecipes = content.node.field_related_recipes.length > 0 ? content.node.field_related_recipes : content.views.relatedContent;
    return (
        <>
            <StructuredData content={content.node} />
            <Container
                backgroundImage={getUrlFromMedia(content.node.field_image ?? '/')}
                className="relative h-[320px] md:h-[500px]"
                overlay={content.node.field_dark_banner === true ? 0.5 : 0}
            >
                <div className="bg-white h-[calc(100px_-_16px)] md:h-[calc(180px_-_32px)] bottom-0 right-0 left-1/2 absolute" />
            </Container>

            <Container
                wrapper
                wrapperSize="max-w-5xl"
                padding="px-2 py-4 md:py-8"
                backgroundColor="bg-white"
            >
                <RecipeArticle
                    displayBullets={content.node.field_display_bullets}
                    className="bg-white -mt-[100px] md:-mt-[180px] pt-6 px-4 md:pt-10 md:px-16"
                    id='article'
                    content={content.node}
                    relatedRecipes={relatedRecipes}
                />
            </Container>
        </>
    )
}
